import classNames from 'classnames';

const cn = classNames;

export default cn;
